import { render } from "./ObservationModalComponent.vue?vue&type=template&id=098446de&scoped=true"
import script from "./ObservationModalComponent.vue?vue&type=script&lang=js"
export * from "./ObservationModalComponent.vue?vue&type=script&lang=js"

import "./ObservationModalComponent.vue?vue&type=style&index=0&id=098446de&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-098446de"]])

export default __exports__